<template>
  <div class="sc-autocomplete-container">
    <input
      type="text"
      class="sc-autocomplete-input-field"
      v-on:keyup="emitKeyDown"
      v-on:focus="onFocus"
      v-on:click="onClick"
      v-on:keyup.40="movingBetweenOptions(true)"
      v-on:keyup.38="movingBetweenOptions(false)"
      v-on:keyup.27="close"
      v-on:keyup.enter="selectOption(elementsToDisplay[selectedIndex])"
      v-on-clickaway="close"
      :maxlength="maxlength"
      v-model="textToDisplay">
      <div
        class="sc-autocomplete-options-list"
        v-show="showOptions">
        <div
          class="sc-autocomplete-options"
          v-for="(item, index) of elementsToDisplay"
          v-bind:class="{ 'sc-autocomplete-option-active' : index === selectedIndex,
                          'sc-autocomplete-element-in-list' : areElementsObjects ? item[labelProp] === textToDisplay : item === textToDisplay }"
          v-on:click="selectOption(item)"
          v-on:mouseover="hoverOverItem(index)"
          :key="index">
            <div class="sc-autocomplete-option-elem">
              <div
                class="sc-autocomplete-option-label">
                  {{ areElementsObjects ? item[labelProp]: item }}
              </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import utilsMixin from '../mixins/utils'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'ScAutocomplete',
  mixins: [utilsMixin, clickaway],
  props: {
    options: {
      type: Array,
      required: true
    },
    labelProp: {
      type: String
    },
    selected: {
      type: Object || String
    },
    maxlength: {
      default: null
    }
  },
  watch: {
    options: function (newVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(this.elementsToDisplay)) {
        this.elementsToDisplay = newVal
        this.doShowOptions()
        this.checkInput()
      }
    },
    selected: function (newVal) {
      this.textToDisplay = newVal[this.labelProp]
    }
  },
  data () {
    return {
      textToDisplay: '',
      elementsToDisplay: [],
      showOptions: false,
      selectedIndex: -1,
      areElementsObjects: false,
      selectedOption: null
    }
  },
  mounted () {
    this.checkInput()
  },
  methods: {
    checkInput () {
      if (this.isNullOrUndefined(this.options)) {
        throw Error('options are missig!')
      }
      if (this.options.length > 1 && this.options[0] instanceof Object) {
        this.areElementsObjects = true
      }
      if (this.options.length > 0) {
        if (this.options.length === 1) {
          this.areElementsObjects = true
          this.elementsToDisplay = this.options
        } else {
          this.elementsToDisplay = JSON.parse(JSON.stringify(this.options))
        }
      }
      if (this.selected) {
        this.textToDisplay = this.selected[this.labelProp]
      }
    },
    onFocus () {
      this.doShowOptions()
      this.$emit('focus')
    },
    onClick () {
      this.doShowOptions()
      this.$emit('click')
    },
    doShowOptions () {
      this.showOptions = this.elementsToDisplay.length > 0
    },
    emitKeyDown () {
      this.doShowOptions()
      this.$emit('keyDown', this.textToDisplay)
    },
    selectOption (option) {
      if (!option) {
        this.close()
      } else {
        this.selectedOption = option
        this.showOptions = false
        this.textToDisplay = this.areElementsObjects || this.dropdown ? option[this.labelProp] : option
        this.selectedIndex = -1
        this.$emit('select', option)
      }
    },
    movingBetweenOptions (isDownArrow) {
      const lastIndex = this.elementsToDisplay.length - 1
      if (this.selectedIndex === -1) {
        this.selectedIndex = isDownArrow ? 0 : lastIndex
      } else {
        isDownArrow ? this.selectedIndex++ : this.selectedIndex--
      }
      if (this.selectedIndex > lastIndex) {
        this.selectedIndex = 0
      } else if (this.selectedIndex < 0) {
        this.selectedIndex = lastIndex
      }
    },
    hoverOverItem (index) {
      this.selectedIndex = index
    },
    close (e) {
      this.showOptions = false
      this.selectedIndex = -1
    }
  }
}
</script>

<style scoped lang="scss">
.sc-autocomplete-input-field {
  border: 1px solid rgb(176, 190, 197);
  outline: none;
  width: 100%;
  padding: 10px;
  font-size: 12pt;
  color: $sc-autocomplete-color;
}
.sc-autocomplete-input-field::-webkit-calendar-picker-indicator {
  display: none;
}
.sc-autocomplete-options-list {
  border: 1px solid rgb(176, 190, 197);
  margin: auto;
  text-align: left;
  cursor: pointer;
  position: absolute;
  z-index: 1;
  width: 100%;
}
.sc-autocomplete-options {
  color: $sc-autocomplete-color;
  background-color: rgb(255, 255, 255);
  padding: 10px;
}
.sc-autocomplete-option-active {
  color: $sc-autocomplete-color;
  background-color: $sc-autocomplete-hover-bg;
}
.sc-autocomplete-element-in-list {
  color: $sc-autocomplete-color-selected;
}
.sc-autocomplete-container {
  width: 100%;
  position: relative;
  margin: auto;
}
.sc-autocomplete-option-elem {
  display: flex;
  justify-content: space-between;
}
.sc-autocomplete-option-label {
  font-size: 16px;
}
</style>
